module.exports = __webpack_public_path__ + "static/media/1Asset 301@4x.a898f3bb.png";